<template lang="pug">
    .animated-suit(ref='animation')
        svg(width='198' height='410' viewBox='-40 0 198 410' fill='none' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet')
            path(d='M107.075 83.652L71.4784 64.0625L66.4238 66.861H60.4014V410L107.075 83.652Z' fill='white')
            path(d='M0 11.9242V0L56.7411 39.2101L16.1196 47.5893L7.73742 13.9653L0 11.9242Z' fill='white')
            path(d='M117.142 11.9242V0L60.4014 39.2101L101.023 47.5893L109.405 13.9653L117.142 11.9242Z' fill='white')
            path(d='M157.41 116.136L152.951 117.31C153.655 115.784 154.007 113.554 152.717 110.972C152.717 110.972 148.727 111.207 144.62 112.381C144.503 110.738 144.033 108.625 142.86 106.161C140.865 108.156 139.809 109.916 139.105 111.442C135.585 108.977 131.947 107.452 131.947 107.452C129.718 109.564 129.366 111.676 129.6 113.437L125.845 110.855C125.845 110.855 129.952 116.723 125.728 128.576C121.504 140.546 128.662 148.762 135.467 149.935C142.273 151.109 151.778 145.593 151.661 132.918C151.661 120.244 157.41 116.136 157.41 116.136Z' fill='#FF0000')
            path(d='M68.7313 88.8C70.702 88.8 72.2995 87.2025 72.2995 85.2318C72.2995 83.2611 70.702 81.6636 68.7313 81.6636C66.7606 81.6636 65.1631 83.2611 65.1631 85.2318C65.1631 87.2025 66.7606 88.8 68.7313 88.8Z' fill='black')
            path(d='M68.7313 193.42C70.702 193.42 72.2995 191.822 72.2995 189.851C72.2995 187.881 70.702 186.283 68.7313 186.283C66.7606 186.283 65.1631 187.881 65.1631 189.851C65.1631 191.822 66.7606 193.42 68.7313 193.42Z' fill='black')
            path(d='M68.7313 297.897C70.702 297.897 72.2995 296.3 72.2995 294.329C72.2995 292.358 70.702 290.761 68.7313 290.761C66.7606 290.761 65.1631 292.358 65.1631 294.329C65.1631 296.3 66.7606 297.897 68.7313 297.897Z' fill='black')
            path(d='M49.803 66.861L44.6409 64.0625L9.15137 83.652L55.8255 410V66.861H49.803Z' fill='white')

</template>
<script>
import * as basicScroll from 'basicscroll';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            const instance = basicScroll.create({
                elem: this.$refs.animation,
                from: 'middle-bottom',
                to: 'top-top',
                direct: true,
                props: {
                    '--opacity': {
                        from: 0,
                        to: 1
                    }
                }
            });
            this.instance = instance;
            this.instance.start();
            this.isInited = true;
        },
        destroyAnimation() {
            if (this.timeline) {
                this.timeline.kill();
                this.timeline = null;
            }
            if (this.instance) {
                this.instance.destroy();
                this.instance = null;
            }
            this.isInited = false;
        }
    },
    beforeDestroy() {
        this.destroyAnimation();
    }
};
</script>
<style lang="scss" scoped>
.animated-suit {
    opacity: var(--opacity);
    will-change: opacity;
    svg {
        display: block;
        margin: 0 auto;
    }
}
</style>
